export const fileContentType = 'application/octet-stream';
